import { connect } from 'react-redux';
import { get } from 'lodash';
import { getSsoCheckSessionUrl } from 'apps/sso/actions/sso';
import SsoSessionSync from '../components/SsoSessionSync';
import { AuthenticationLevel } from 'auth';
import { cookiesEnabled } from 'utils/cookies';

export default connect((state, ownProps) => ({
  betaFeatures: state.user.betaFeatures,
  customerDetails: state.user.customerDetails,
  cookiesEnabled,
  viewMode: get(state, 'user.customerSession.viewMode'),
  isSuperuser: get(state, 'user.authenticationLevel') === AuthenticationLevel.SUPERUSER,
  currentRoute: ownProps.location.pathname + ownProps.location.search.toLowerCase(),
}), {
  getSsoCheckSessionUrl,
})(SsoSessionSync);
